import { queryStringify } from '@/ultils'
import axiosClient from '../axiosClient'
import { SearchController } from '@/store/slices/Diagnostic/types'

export const controllerApi = {
  getAll(searchParams: SearchController) {
    const url = `/api/Controller/${searchParams.interfaceId}`
    return axiosClient.get(url + queryStringify(searchParams))
  },
  getSubInterface(interfaceId: number) {
    const url = `/api/interface/${interfaceId}/subs`
    return axiosClient.get(url)
  },
}

export default controllerApi
